import { useQuery } from 'react-query';
import { createFetchAPI } from '../http';
import { CompanyIdRequest } from './types';

const fetchCompanyBankAccounts = createFetchAPI<
  CompanyIdRequest,
  FetchCompanyBankAccountsResponse
>();

export const useFetchCompanyBankAccounts = (props: CompanyIdRequest) =>
  useQuery<FetchCompanyBankAccountsResponse>(
    [
      'fetchCompanyBankAccounts',
      { url: `v1/companies/${props.company_id}/finance_accounts` },
    ],
    fetchCompanyBankAccounts,
  );

export type FetchCompanyBankAccountsResponse = {
  finance_accounts: FinanceAccount[];
  count: number;
};

type FinanceAccount = {
  id: string;
  bank_account_name: string;
  bank_account_number: string;
};
